import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与)
import { useTranslation } from 'react-i18next';

type Props = {
    // buttonText: string,
    // languageExchange:any,
}
export const MyPageTitle: React.FC<Props> = (props) => {
  const [t, i18n] = useTranslation();
  // margin-top: 100px;
  const MyPageTitleComponent = styled.p`
    font-weight: 700;
    margin-top: 35px;
    font-size: 26px;
    margin-bottom: 10px;

  `;
  return (
    <MyPageTitleComponent id='mypagetitle'>{t('マイページ')}</MyPageTitleComponent>
  );
};